








import { CreateElement, VNode } from 'vue';
import { Component, Prop, Provide, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import { ProvidedFormParam } from './types';
import { utilService } from '../util-service';

@Component
export default class SwForm extends SwExtendedVue {
  @Prop({ type: String, default: undefined })
  action: string;

  @Prop({ type: String, default: 'application/x-www-form-urlencoded' })
  enctype: string;

  @Prop({ type: String, default: undefined })
  target: string;

  @Prop({ type: String, default: 'post' })
  method: 'post' | 'get';

  @Prop({ type: [Number, String], default: 200 })
  labelWidth: number | string;

  /** when `=== true`, it will use div instead of form as the root element */
  @Prop({ type: Boolean, default: false })
  layoutOnly: boolean;

  @Provide()
  formParam: ProvidedFormParam = {
    labelWidth: this.labelWidth,
  };

  @Watch('labelWidth')
  syncLableWidth(val: number | string) { this.formParam.labelWidth = val; }

  render(h: CreateElement): VNode {// tslint:disable-line
    let rootNode: VNode | null = null;

    if (this.layoutOnly) {
      rootNode = (
        <div class={['sw-form']}>{ utilService.getVueScopedSlot(this.$scopedSlots) }</div>
      ) as VNode;
    } else {
      rootNode = (
        <form class={['sw-form']}
          action={this.action}
          method={this.method}
          target={this.target}
          enctype={this.enctype}
        >
        { utilService.getVueScopedSlot(this.$scopedSlots) }
        </form>
      ) as VNode;
    }

    return rootNode;
  }
}
